import React from 'react'
import ContactUs from '../fetures/contact-us/ContactUs'

const ContactUsPage = () => {
  return (
    <ContactUs/>
  )
}

export default ContactUsPage